import React, { useEffect } from 'react';
import { Link } from "react-router-dom";

const EceleftTab = () => {
    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }, []);

    const scrollWin = () => {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    };

    return (
        <div className="additional-information">
            <div className="list">
                <ul className='text-start'>

                    <Link to="/dept/ece" ><li><i className="fas fa-info-circle"></i> <span>About the Department</span></li></Link>
                    <Link to="/dept/ece/vision-mission-peos" ><li><i className="fas fa-bullseye"></i> <span>Vision, Mission & PEO’s</span></li></Link>
                    <Link to="/dept/ece/po-and-pso" ><li><i className="fas fa-project-diagram"></i> <span>PO and PSO’s</span></li></Link>
                    <Link to="/dept/ece/hod" ><li><i className="fas fa-user-tie"></i> <span>HOD</span></li></Link>
                    <Link to="/dept/ece/ece-faculty" ><li><i className="fas fa-chalkboard-teacher"></i> <span>Faculty List</span></li></Link>
                    <Link to="/dept/ece/department-academic-calendar" ><li><i className="fas fa-calendar-alt"></i> <span>Academic Calendar</span></li></Link>
                    <Link to="/dept/ece/events" ><li><i className="fas fa-calendar-check"></i> <span>Events</span></li></Link>
                    <Link to="/dept/ece/student-projects" ><li><i className="fas fa-lightbulb"></i> <span>Student Projects</span></li></Link>
                    <Link to="/dept/ece/industry-internship" ><li><i className="fas fa-briefcase"></i> <span>Industry Internship</span></li></Link>
                    <Link to="/dept/ece/industry-visits" ><li><i className="fas fa-industry"></i> <span>Industrial Visits</span></li></Link>
                    <Link to="/dept/ece/student-development-programs" ><li><i className="fas fa-graduation-cap"></i> <span>SDP</span></li></Link>
                    <Link to="/dept/ece/syllabus" ><li><i className="fas fa-book-open"></i> <span>Syllabus</span></li></Link>
                    <Link to="/dept/ece/result-analysis" ><li><i className="fas fa-chart-bar"></i> <span>Result Analysis</span></li></Link>
                    <Link to="/dept/ece/placements" ><li><i className="fas fa-user-graduate"></i> <span>Placements & Higher Studies</span></li></Link>
                    <Link to="/dept/ece/previous-years-placements" ><li><i className="fas fa-user-graduate"></i> <span>Previous Years Placements </span></li></Link>
                    <Link to="/dept/ece/professional-bodies" ><li><i className="fas fa-users"></i> <span>Professional Bodies</span></li></Link>
                    <Link to="/dept/ece/magazines" ><li><i className="fas fa-newspaper"></i> <span>Magazines & Newsletters</span></li></Link>
                    {/* <Link to="/dept/ece/student-publications" ><li><i className="fas fa-trophy"></i> <span>Student Publications</span></li></Link> */}
                    <Link to="/dept/ece/faculty-innovations" ><li><i className="fas fa-lightbulb"></i> <span>Faculty Innovations</span></li></Link>
                    <Link to="/dept/ece/workshops" ><li><i className="fas fa-tools"></i> <span>Workshops/FDPs</span></li></Link>
                    <Link to="/dept/ece/faculty-performance" ><li><i className="fas fa-chart-line"></i> <span>Faculty Performance</span></li></Link>
                    <Link to="/dept/ece/laboratory-projects" ><li><i className="fas fa-flask"></i> <span>R&D Labs & Projects</span></li></Link>
                    <Link to="/dept/ece/academic-sponsered" ><li><i className="fas fa-hand-holding-usd"></i> <span>Sponsored Research</span></li></Link>
                    <Link to="/dept/ece/industry-supported-lab">
                        <li><i className="fas fa-flask"></i> <span>Industry Supported Lab</span></li>
                    </Link>

                    <a href="#" ><li><i className="fas fa-archive"></i> <span>Bridge Files</span></li></a>
                    <Link to="/dept/ece/course-files" ><li><i className="fas fa-folder-open"></i> <span>Course Files</span></li></Link>
                    <a href="/dept/ece/labarotories" ><li><i className="fas fa-microscope"></i> <span>Laboratories</span></li></a>
                    <Link to="/dept/ece/department-library" ><li><i className="fas fa-book-reader"></i> <span>Department Library</span></li></Link>
                    <Link to="/dept/ece/department-mous" ><li><i className="fas fa-file-signature"></i> <span>MOUs</span></li></Link>

                </ul>
            </div>
        </div>
    );
}

export default EceleftTab;
